import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  email: "",
  fullname: "",
  main_img: null,
  phone: "",
  token: "",
  user_type_id: 0,
  username: "",
  role: null,
  dataPrivileges: [],
};

export const UserSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.id = action?.payload?.id || action?.payload?.uuid;
      state.email = action?.payload?.email;
      state.fullname =
        action?.payload?.fullname ||
        `${action?.payload?.firstName || ""} ${action?.payload?.lastName || ""}`.trim();
      state.main_img = action?.payload?.main_img;
      state.phone = action?.payload?.phone;
      state.token = action?.payload?.token;
      state.user_type_id = action?.payload?.user_type_id;
      state.username =
        action?.payload?.username || action?.payload?.firstName || "";
      state.role = action?.payload?.role || null;
    },
    removeUserInfo: (state, action) => {
      state.id = 0;
      state.email = "";
      state.fullname = "";
      state.main_img = "";
      state.phone = "";
      state.token = "";
      state.user_type_id = 0;
      state.username = "";
      state.role = null;
    },
    setDataPrivileges: (state, action) => {
      state.dataPrivileges = action.payload;
    },
  },
});

export const { setUserInfo, setDataPrivileges, removeUserInfo } =
  UserSlice.actions;

export default UserSlice.reducer;
